import { useCustomerPricingTierContext } from '@src/providers';
import { logger, type AllInTier, type FeeTier, type SymbolGroup } from '@talos/kyoko';
import { useEffect, useState } from 'react';

export interface CustomerTierOptions {
  allInTiers: AllInTier[];
  feeTiers: FeeTier[];
  symbolGroups: SymbolGroup[];
}

export function useCustomerTierOptions(enabled: boolean): CustomerTierOptions | undefined {
  const [options, setOptions] = useState<CustomerTierOptions>();
  const { getAllInTiers, getFeeTiers, getSymbolGroups } = useCustomerPricingTierContext();

  useEffect(() => {
    if (!enabled) {
      setOptions(undefined);
      return;
    }

    let isCurrent = true;
    Promise.all([getAllInTiers(), getFeeTiers(), getSymbolGroups()])
      .then(([{ data: allInTiers }, { data: feeTiers }, { data: symbolGroups }]) => {
        if (isCurrent) {
          setOptions({ allInTiers, feeTiers, symbolGroups });
        }
      })
      .catch(error => {
        logger.warn('Failed to load customer tier options', { error });
        if (isCurrent) {
          setOptions({ allInTiers: [], feeTiers: [], symbolGroups: [] });
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, getAllInTiers, getFeeTiers, getSymbolGroups]);

  return options;
}
